export const addCommas = (value, d = 2) => {
  if (typeof value === 'number') {
    const result = value.toLocaleString(undefined, {
      minimumFractionDigits: d,
      maximumFractionDigits: 4,
    });
    return result;
  } if (typeof value === 'string') {
    const newValue = parseFloat(value);
    const result = newValue.toLocaleString(undefined, {
      minimumFractionDigits: d,
      maximumFractionDigits: 4,
    });
    return result;
  }
  return '0.00';
};

export default addCommas;
